angular.module('dnecom')
    .controller('StoreGeneralAppearanceSettingsController', ["$scope", "StoreUtils", "MediaUtils", function ($scope, StoreUtils, MediaUtils) {
        $scope.urlUploadBtnText = 'Upload from url';
        $scope.urlUploading = false;
        $scope.mobileLogoMarkedForDelete = false;
        $scope.faviconMarkedForDelete = false;
        $scope.logo = {
            url: '',
        };
        $scope.faviconFileError = false;
        $scope.logoFileError = false;
        $scope.mobileLogoFileError = false;
        var logoMarkedForDelete = false;

        $scope.isLogoMarkedForDelete = function () {
            return logoMarkedForDelete;
        };

        $scope.cancelLogoDeletion = function () {
            logoMarkedForDelete = false;
        };

        $scope.markLogoForDelete = function () {
            logoMarkedForDelete = true;
        };

        $scope.save = function (form) {
            // copy value and restore on fail
            var currentLogo = $scope.store.logo;
            var currentMobileLogo = $scope.store.properties.general.mobileLogo;

            if (logoMarkedForDelete) {
                $scope.store.logo = {};
            }

            if ($scope.mobileLogoMarkedForDelete) {
                $scope.store.properties.general.mobileLogo = {};
            }
            if ($scope.faviconMarkedForDelete) {
                $scope.store.properties.general.favicon = {};
            }

            if (!$scope.$parent.save(form)) {
                $scope.store.logo = currentLogo;
                $scope.store.properties.general.mobileLogo = currentMobileLogo;

                return false;
            }

            if (logoMarkedForDelete && currentLogo.id) {
                MediaUtils.scheduleDelete(currentLogo.id);
            }

            if ($scope.mobileLogoMarkedForDelete && currentMobileLogo.id) {
                MediaUtils.scheduleDelete(currentMobileLogo.id);
            }

            if ($scope.faviconMarkedForDelete && currentFavicon.id) {
                MediaUtils.scheduleDelete(currentFavicon.id);
            }

            MediaUtils.processDelete();
            $scope.cancelLogoDeletion();
            $scope.cancelMobileLogoDeletion();
            $scope.cancelFaviconDeletion();

            return true;
        };

        $scope.reset = function () {
            if ($scope.store.logo) {
                MediaUtils.scheduleDelete($scope.store.logo.id);
            }

            if ($scope.store.properties.general.mobileLogo) {
                MediaUtils.scheduleDelete($scope.store.properties.general.mobileLogo.id);
            }

            if ($scope.store.properties.general.favicon) {
                MediaUtils.scheduleDelete($scope.store.properties.general.favicon.id);
            }

            $scope.cancelLogoDeletion();
            $scope.$parent.reset();

            if ($scope.store.logo) {
                MediaUtils.cancelDelete($scope.store.logo.id);
            }

            MediaUtils.processDelete();
        };

        $scope.storeChanged = function () {
            return $scope.$parent.storeChanged() || $scope.isLogoMarkedForDelete();
        };

        $scope.uploadLogo = function (file) {
            $scope.logoFileError = !file ? true : false;
            StoreUtils.upload($scope.store, file, function (media) {
                if ($scope.store.logo) {
                    MediaUtils.scheduleDelete($scope.store.logo.id);
                }
                $scope.store.logo = media;
                $scope.cancelLogoDeletion();
            });
        };

        $scope.uploadLogoUrl = function (url) {
            if (url && url.length > 0) {
                $scope.urlUploadBtnText = 'Uploading...';
                $scope.urlUploading = true;

                StoreUtils.uploadUrl($scope.store, url, function (media) {
                    if ($scope.store.logo) {
                        MediaUtils.scheduleDelete($scope.store.logo.id);
                    }
                    $scope.store.logo = media;
                    $scope.cancelLogoDeletion();
                    $scope.urlUploadBtnText = 'Upload from url';
                    $scope.urlUploading = false;
                    $scope.logo.url = '';
                }, () => {
                    $scope.urlUploadBtnText = 'Upload from url';
                    $scope.urlUploading = false;
                });
            }
        };

        var getStoreField = function (field) {
            return StoreUtils.getFieldValue($scope.store, 'general', field);
        };

        var setStoreField = function (field, value) {
            StoreUtils.setFieldValue($scope.store, 'general', field, value);
        };

        $scope.resetStoreField = function (field) {
            setStoreField(field, $scope.defaultProperties['general'][field]);
        };

        $scope.isDefaultFieldValue = function (field) {
            return getStoreField(field) == null
                || getStoreField(field).length == 0
                || getStoreField(field) == $scope.defaultProperties['general'][field];
        };

        $scope.uploadMobileLogo = function (file) {
            $scope.mobileLogoFileError = !file ? true : false;
            StoreUtils.upload($scope.store, file, function (media) {
                $scope.store.properties.general.mobileLogo = media;
            });
        };

        $scope.uploadFavicon = function (file) {
            $scope.faviconFileError = !file ? true : false;
            StoreUtils.upload($scope.store, file, function (media) {
                $scope.store.properties.general.favicon = media;
            });
        };

        $scope.deleteMobileLogo = function () {
            $scope.mobileLogoMarkedForDelete = true;
        };

        $scope.deleteFavicon = function () {
            $scope.faviconMarkedForDelete = true;
        };

        $scope.cancelMobileLogoDeletion = function () {
            $scope.mobileLogoMarkedForDelete = false;
        };

        $scope.cancelFaviconDeletion = function () {
            $scope.faviconMarkedForDelete = false;
        };
    }]);
